<template>
	<main class="drip-campaigns">
		<router-view />
	</main>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import dripCampaignService from '@/services/toolbox/drip-campaign-service';

export default {
	name: 'DripCampaignsHome',
	computed: {
		...mapState({
			contactId: (state) =>
				state.profileSwitcher.profileSelector.rolodexContactId,
			entityId: (state) =>
				!!state.profileSwitcher.brokerDetails[0] // when impersonating array has an item
					? state.profileSwitcher.brokerDetails[0].shopDetail.entityId
					: state.profileSwitcher.profileSelector.brokerShopDetails[0]
							.shopDetail.rolodexEntityId,
			campaigns: (state) => state.dripCampaigns.all.list,
		}),
		...mapGetters(['isImpersonated', 'currentDripCampaign']),
	},
	methods: {
		...mapActions([
			'getAllDripCampaigns',
			'resetCurrentDripCampaign',
			'setCurrentCampaign',
			'getCurrentDripCampaignById',
			'getCurrentDripCampaignSettings',
		]),
		async getCurrentCampaign() {
			await this.getCurrentDripCampaignById(
				this.$route.params.dripCampaignId,
				this.contactId,
				this.entityId,
			);
		},
		async getCampaignData() {
			if (this.$route.name === 'drip-campaigns-overview') {
				// Show loading indicator if we are impersonating or we don't have all the campaigns
				const showLoading =
					this.isImpersonated || !this.campaigns || this.campaigns.length <= 1;
				const dripRequest = {
					showLoading: showLoading,
					contactId: this.contactId,
					entityId: this.entityId,
				};
				await this.getAllDripCampaigns(dripRequest);
			} else if (this.$route.params.dripCampaignId) {
				this.resetCurrentDripCampaign();
				this.setCurrentCampaign(this.$route.params.dripCampaignId);
				this.getCurrentCampaign();
			}
		},
	},
	watch: {
		'$route.params': {
			handler: 'getCampaignData',
			immediate: true,
		},
		contactId() {
			this.getCampaignData();
		},
	},
	beforeDestroy() {
		this.resetCurrentDripCampaign();
	},
};
</script>

<style lang="scss" scoped>
.drip-campaigns {
	@include rem('padding-bottom', 15px);

	@media screen and (min-width: 600px) {
		@include rem('padding-bottom', 20px);
	}
}
</style>
